export default __webpack_public_path__ + "assets/images/3958346d6c062265fafe277c7e94f024.png";